export const NAME_VALIDATOR = 'name';
export const USER_ID_VALIDATOR = 'userId';
export const LOCATION_VALIDATOR = 'location';
export const SIX_DIGITS_VALIADATOR = 'sixDigits';
export const EMAIL_VALIADATOR = 'email';
